import {useState} from "react";
import InvitationsView, {
  InvitationsProps as _InvitationsProps,
  InvitationsStateProps,
  InvitationsDOMProps as _InvitationsDOMProps,
  InvitationsModalVisibilityProps as _InvitationsModalVisibilityProps,
} from "./invitations-view";
import { FeedbackContainerProps, withFeedback } from "../../feedback";
import {OrganizationGroupInvitationWithExpiredStatus} from "../../../utils/invitation";
export { ModalKeys } from "./invitations-view";

export type InvitationsDOMProps = _InvitationsDOMProps;
export type InvitationsModalVisibilityProps = _InvitationsModalVisibilityProps;

export interface InvitationsProps
  extends Omit<_InvitationsProps, keyof InvitationsStateProps> {}

function Invitations(props: InvitationsProps & FeedbackContainerProps) {
  const [selected, setSelected] = useState([] as OrganizationGroupInvitationWithExpiredStatus[]);
  const viewProps: _InvitationsProps = {
    selected: selected,
    onSetSelected: setSelected,
    ...props,
  };
  return <InvitationsView {...viewProps} />;
}
export default withFeedback<InvitationsProps & FeedbackContainerProps>(
  Invitations
);
